export const tr = {
    
  "__currency_code__":"TRY",
  "__currency__":"TL",
  "__currency_symbol__":"₺",
  "__locale__":"tr-TR",

  "2d": "2D",
  "3d": "3D",
  confirm: "Onayla",
  confirmshape: "Şekli Güncelle",
  notFound: "Bulunamadı",
  next: "İleri",
  back: "Geri",
  export: "Dışarı Aktar",
  search: "Ara",
  gapWidth: "Boşluk Genişliği",
  wallWidth: "Duvar Genişliği",
  balconyWidth: "Balkon Genişliği",
  clearAllTip: "Tümünü Temizle",
  drawBalconyTip: "Balkon Çiz",
  drawWallTip: "Duvar Çiz",
  drawGapTip: "Boşluk Çiz",
  //WelcomeMenu.tsx
  welcomeMenuWelcome: "Merhaba!  Planlayıcıya Hoş Geldiniz!",
  drawRoomShape: "Kendi Odanı Çiz",
  chooseRoomShapeFromTemplates: "Hazır Şekillerden Seç",
  chooseRoomShape: "Oda Şeklini Seç",
  //MainPane.tsx
  roomFeatures: "Ölçüler",
  drawWall: "Şablonlar",
  showReport: "Proformo",
  addToRoom: "Ürünler",
  configure: "Konfigürasyon",
  //RoomShaping.tsx
  changeRoomShape: "Oda Şeklini Değiştir",
  newRoom: "Temizle",
  roomShapeOnlyFloor: "Zemin",
  roomShapeFloorWithSingleWall: "Tek Duvar",
  roomShapeCorner: "Köşe",
  roomShapeRectangle: "Dikdörtgen",
  roomShapeSquare: "Kare",
  roomShapeLShape: "L Şekli",
  roomShapeUShape: "U Şekli",
  roomShapeTShape: "T Şekli",
  roomShape5Sides: "5 Kenarlı",
  roomDoubleBalcony: "Köşe",
  roomShapeZShape: "Z Şekli",
  roomShapeBevelShape: "Kesik Şekli",

  //RoomModifying.tsx
  wallResize: "Duvarları Yeniden Boyutlandır",
  glassPriceMultiplier: "Cam Metre Fiyatı",
  basePriceMultiplier: "Taban Birim Fiyatı",
  buyerName: "Alıcı Adı",
  dimensions: "Boyutlar",
  resetArea: "Alanı Sıfırla",
  undo: "Geri Al",
  topView: "Üstten Görüş",
  createRender: "Render Al",
  calculating: "Hesaplanıyor...",
  loading: "Yükleniyor...",
  productList: "Ürün Listesi",
  proforma: {
    modelSummary: "Normod Tasarım Özeti",
    pdfGenerating: "PDF oluşturuluyor...",
    pdfLibraryError: "PDF kütüphanesi yüklenemedi",
    pdfError: "PDF oluşturulamadı. Lütfen tekrar deneyin.",
    pdfError2: "PDF oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.",
    offerNo: "Teklif No",
    quantity: "Adet",
    product: "Ürün",
    price: "Fiyat",
    subtotal: "Ara Toplam",
    dimensions: "Boyutlar",
    materialType: "Kumaş Tipi",
    materialColor: "Kumaş Rengi",
    orderDate: "Sipariş Tarihi",
    discount: "İndirim",
    taxIncluded: "Vergi(Dahil) KDV- 10%",
    total: "GENEL TOPLAM",
    footer1: "Fiyatlarımıza KDV dahildir.",
    footer2: "Fiyatlar formun oluşturulduğu gün için geçerlidir.",
    footer3: "Bu form teklif amaçlı olup sipariş amaçlı kullanılamaz.",
    footer4: "Bu tasarım kişiye özel olarak {{date}} tarihinde hazırlanmıştır.",
    footer5:
      "Ürünlerimiz konfor odaklı tasarlanmaktadır. Oldukça zengin elyaf ve elastikiyeti yüksek premium süngerler kullanıldığı için dikişler sert ve düz çizgiler şeklinde olmayabilir.",
    footer6: "Ekrandaki renkler ton değişiklikleri gösterebilir.",
    footer7: "Teklifin geçerlilik süresi 3 gündür.",
    preview3d: "3D Görünüm",
    setProjectName: "Proje Adını Belirleyin",
    pdfWillBeSavedAs: "PDF dosyası bu isimle kaydedilecektir",
    projectName: "Proje Adı",
    projectNamePlaceholder: "Örn: Mutfak Tasarımı",
    cancel: "İptal",
    createPdf: "PDF Oluştur",
    priceAsc: "Fiyat ↑",
    priceDesc: "Fiyat ↓",
    sort: "Sırala",
    productDetails: "Ürünün Detayları",
    cm: "cm",
    addToCart: "Sepete Ekle",
    share: "Paylaş",
  },
  tips: {
    doneBtnText: "Anladım",
    onboarding: {
      welcomeTitle: "Room Designer'a Hoşgeldiniz!",
      welcomeDesc: "Bu kısa tur size tasarım araçlarını tanıtacak. İstediğiniz zaman kapatabilirsiniz.",
      canvasTitle: "Tasarım Alanınız",
      canvasDesc: "Odanızı burada görecek ve düzenleyeceksiniz. 2D modda duvar çizebilir, 3D modda ürünleri yerleştirip önizleme yapabilirsiniz.",
      toolbarTitle: "Araç Çubuğu",
      toolbarDesc: "Çizim araçları, geri alma ve görünüm değiştirme butonları burada. Şimdi tek tek bakalım.",
      viewModeTitle: "Görünüm Modu",
      viewModeDesc: "2D: Duvar çizimi ve plan görünümü. 3D: Gerçekçi önizleme ve ürün yerleştirme. Aralarında geçiş yapabilirsiniz.",
      undoTitle: "Geri Al / İleri Al",
      undoDesc: "Yaptığınız işlemleri geri alabilir veya tekrar uygulayabilirsiniz.",
      drawWallTitle: "Duvar Çiz",
      drawWallDesc: "Bu aracı seçtikten sonra tasarım alanında tıklayarak duvar köşelerini belirleyin. Başlangıç noktasına tıklayarak odayı kapatabilirsiniz.",
      balconyTitle: "Balkon Ekle",
      balconyDesc: "Balkon çizmek için bu aracı kullanın. Duvar gibi noktalar arasında tıklayarak çizim yapın.",
      panelTitle: "Ürün ve Malzeme Paneli",
      panelDesc: "Bu panelden ürünleri, malzemeleri ve oda özelliklerini yönetin. Üstteki sekmeler ile kategoriler arasında gezinin.",
      categoriesTitle: "Kategoriler",
      categoriesDesc: "Oda Özellikleri, Ürünler, Malzemeler ve Dış Aktar sekmelerini burada bulabilirsiniz.",
      helpTitle: "Yardıma İhtiyacınız Olursa",
      helpDesc: "Bu butona tıklayarak bu turu istediğiniz zaman tekrar başlatabilirsiniz. İyi tasarımlar!",
    },
    contextual: {
      threeDModeTitle: "3D Görünümdesiniz",
      threeDModeDesc: "Sağ tıklayıp sürükleyerek kamerayı döndürebilirsiniz. Mouse tekerleği ile yakınlaştırıp uzaklaştırabilirsiniz.",
      drawerActiveTitle: "Çizim Modu Aktif",
      drawerActiveDesc: "Tasarım alanında tıklayarak köşe noktaları belirleyin. Çizimi tamamlamak için başlangıç noktasına tekrar tıklayın veya çift tıklayın.",
      productSelectedTitle: "Ürün Seçildi",
      productSelectedDesc: "Bu açılan menüden ürünü döndürebilir, silebilir veya başka bir ürünle değiştirebilirsiniz.",
      wallSelectedTitle: "Duvar Ayarları",
      wallSelectedDesc: "Bu pencereden duvar tipini değiştirebilir ve boyutları ayarlayabilirsiniz.",
      cornerButtonsTitle: "Duvar Ekleme Noktası",
      cornerButtonsDesc: "Bu '+' butonlarına tıklayarak mevcut köşelere yeni duvar ekleyebilirsiniz.",
      backTo2dTitle: "2D Moddasınız",
      backTo2dDesc: "Şimdi duvar çizebilir, duvar boyutlarını değiştirebilir ve plan görünümünde çalışmaya devam edebilirsiniz.",
    },
    progress: {
      roomCreatedTitle: "Odanız Hazır!",
      roomCreatedDesc: "Şimdi sağ paneldeki 'Ürünler' sekmesinden mobilya ve aksesuar ekleyebilirsiniz. Sürükle-bırak veya tıklayarak ekleyin.",
      firstProductTitle: "İlk Ürün Eklendi!",
      firstProductDesc: "Ürüne tıklayarak seçin, ardından döndürün, silin veya başkasıyla değiştirin. 3D görünüme geçip nasıl göründüğünü kontrol edin.",
      threeDPreviewTitle: "3D Önizleme Harika Görünüyor!",
      threeDPreviewDesc: "'Malzemeler' sekmesinden duvar, zemin ve tavan malzemelerini değiştirebilirsiniz.",
      materialChangedTitle: "Tasarımınız Şekilleniyor!",
      materialChangedDesc: "Hazır olduğunuzda 'Dış Aktar' sekmesinden tasarımınızı kaydedebilir veya paylaşabilirsiniz.",
      wallResizedTitle: "Duvar Boyutu Güncellendi",
      wallResizedDesc: "3D görünüme geçerek değişikliklerin nasıl göründüğünü kontrol edin.",
    },
  },
  side: {
    backCushion: "Sırt Minderi",
    armOption: "Kol Seçeneği",
    fabricDetails: "Kumaş Detayları",
    apply: "Uygula",
    materialGroupDescription:
      "Bulunan kumaş tiplerinden seç ve onun alt grubundan istediğin rengi seçip ürününü özelleştir.",
  },
};
